import {createAction, props} from "@ngrx/store";
import {UserSettings} from "./user.model";

export const updateUserSettings = createAction(
  '[Update User] User',
  props<{ user: UserSettings }>()
);
